module.exports = __webpack_public_path__ + "web/img/verify6.71b51464.jpg";